// Import global declaration for projects consuming this package
/// <reference types="./global" />
import { createRoot } from 'react-dom/client';
import { App } from './app';
import { initGoogleMapsAPI } from './features/google-maps';
import { initSentry } from './features/sentry';

export function init() {
  const el = document.getElementById('root');

  if (!el) {
    throw new Error('root element not found');
  }

  const root = createRoot(el);
  root.render(<App />);
}

if (process.env.NODE_ENV !== 'production') {
  new EventSource('/esbuild').addEventListener('change', () =>
    window.location.reload(),
  );
}

initSentry();
init();
initGoogleMapsAPI();

export default App;
